import { render, staticRenderFns } from "./documentList.vue?vue&type=template&id=013993d0&scoped=true&"
import script from "./documentList.vue?vue&type=script&lang=js&"
export * from "./documentList.vue?vue&type=script&lang=js&"
import style0 from "./documentList.vue?vue&type=style&index=0&id=013993d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013993d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('013993d0')) {
      api.createRecord('013993d0', component.options)
    } else {
      api.reload('013993d0', component.options)
    }
    module.hot.accept("./documentList.vue?vue&type=template&id=013993d0&scoped=true&", function () {
      api.rerender('013993d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chatbotManagement/documentList.vue"
export default component.exports